import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ssc-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements AfterViewInit {
  @Input() public showContactButton = false;

  @ViewChild('contactBtn') private contactBtn: ElementRef;
  @ViewChild('imprint') private imprint: ElementRef;

  public showContactOverlay = false;

  public contactBtnMoveBottom: boolean;
  public imprintMoveLeft: boolean;

  private imprintIsIntersecting: boolean;
  private readonly navigationBarId: string = 'navigation-bar';
  private navigationBarElement: HTMLElement | null;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  public ngAfterViewInit(): void {
    this.showContactButton = true;

    this.navigationBarElement = document.getElementById(this.navigationBarId);

    const resizeObserver = new ResizeObserver(() => {
      if (this.imprintIsIntersecting) {
        this.setImprintMoveLeft(this.imprintIsIntersecting);
        this.changeDetectorRef.markForCheck();
      }
    });

    resizeObserver.observe(window.document.body);
  }

  public setContactBtnMoveBottom(value: boolean): void {
    if (this.navigationBarElement) {
      this.contactBtnMoveBottom = !value;
    }
  }

  public setImprintMoveLeft(value: boolean): void {
    this.imprintIsIntersecting = value;
    this.imprintMoveLeft =
      value &&
      this.imprint.nativeElement.offsetLeft + this.contactBtn.nativeElement.offsetWidth >
        this.contactBtn.nativeElement.offsetLeft;
  }
}
